const loggedOutTemplateUrl = require('./logged-out.html');

module.exports = function($stateProvider) {
  $stateProvider.state('notLoggedIn', {
    templateUrl: loggedOutTemplateUrl
  });
};

module.exports.$inject = ['$stateProvider'];
